import React from 'react';

const ConfidenceIntervalsStatistics = (props) => {
    let confidenceIntervalsTable =
        props.getAnalysisRes.confidence_intervals.statistics;

    // let regHeaders = [];
    let confidenceIntervalsRows = [];

    for (let i = 0; i < Object.keys(confidenceIntervalsTable).length; i++) {
        // console.log(Object.keys(data)[i])
        confidenceIntervalsRows.push(
            Object.values(confidenceIntervalsTable)[i]
        );
    }

    // let newConfidenceIntervalsRows = Object.keys(confidenceIntervalsTable).map(
    //     (key) => {
    //         let item = confidenceIntervalsTable[key];
    //         let fixedValue = item.value;

    //         let cI = [
    //             'crit_t_stat',
    //             'avg_interval_lower',
    //             'avg_interval_upper'
    //         ];

    //         return (
    //             <>
    //                 {cI.includes(key) ? (
    //                     <>
    //                         <Col
    //                             span={{ xs: 12, sm: 8, md: 4, lg: 3 }}
    //                             style={{ marginTop: 10 }}
    //                         >
    //                             <Card>
    //                                 <Statistic
    //                                     key={item.display_name}
    //                                     title={item.display_name + ' 50%'}
    //                                     value={fixedValue[0]}
    //                                 />
    //                             </Card>
    //                         </Col>
    //                         <Col
    //                             span={{ xs: 12, sm: 8, md: 4, lg: 3 }}
    //                             style={{ marginTop: 10 }}
    //                         >
    //                             <Card>
    //                                 <Statistic
    //                                     key={item.display_name}
    //                                     title={item.display_name + ' 68%'}
    //                                     value={fixedValue[1]}
    //                                 />
    //                             </Card>
    //                         </Col>
    //                         <Col
    //                             span={{ xs: 12, sm: 8, md: 4, lg: 3 }}
    //                             style={{ marginTop: 10 }}
    //                         >
    //                             <Card>
    //                                 <Statistic
    //                                     key={item.display_name}
    //                                     title={item.display_name + ' 90%'}
    //                                     value={fixedValue[2]}
    //                                 />
    //                             </Card>
    //                         </Col>
    //                         <Col
    //                             span={{ xs: 12, sm: 8, md: 4, lg: 3 }}
    //                             style={{ marginTop: 10 }}
    //                         >
    //                             <Card>
    //                                 <Statistic
    //                                     key={item.display_name}
    //                                     title={item.display_name + ' 95%'}
    //                                     value={fixedValue[3]}
    //                                 />
    //                             </Card>
    //                         </Col>
    //                     </>
    //                 ) : (
    //                     <Col
    //                         span={{ xs: 12, sm: 8, md: 4, lg: 3 }}
    //                         style={{ marginTop: 10 }}
    //                     >
    //                         <Card>
    //                             <Statistic
    //                                 key={item.display_name}
    //                                 title={item.display_name}
    //                                 value={fixedValue}
    //                             />
    //                         </Card>
    //                     </Col>
    //                 )}
    //             </>
    //         );
    //     }
    // );

    // let statConfidenceIntervalsTable = (
    //     <>
    //         <div>
    //             <Row className="statistics-row-box" gutter={16}>
    //                 {newConfidenceIntervalsRows}
    //             </Row>
    //         </div>
    //     </>
    // );

    let newStatsConfidenceIntervalsRows2 = Object.keys(
        confidenceIntervalsTable
    ).map((key) => {
        let item = confidenceIntervalsTable[key];
        let fixedValue = item.value;

        let cI = ['crit_t_stat', 'avg_interval_lower', 'avg_interval_upper'];

        return (
            <>
                {!cI.includes(key) && (
                    <tr>
                        <td className="title">{item.display_name}</td>
                        <td className="value">{fixedValue}</td>
                    </tr>
                )}
            </>
        );
    });

    let statConfidenceIntervalsTable2 = (
        <>
            <div key="12341">
                <div>
                    <div>
                        <table className="table-cis" style={{ marginTop: 0 }}>
                            <tbody>{newStatsConfidenceIntervalsRows2}</tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );

    let newStatsConfidenceIntervalsRows3 = Object.keys(
        confidenceIntervalsTable
    ).map((key) => {
        let item = confidenceIntervalsTable[key];
        let fixedValue = item.value;

        let cI = ['crit_t_stat', 'avg_interval_lower', 'avg_interval_upper'];

        return (
            <>
                {cI.includes(key) && (
                    <tr>
                        <td className="value">{item.display_name}</td>
                        <td className="value">{fixedValue[0]}</td>
                        <td className="value">{fixedValue[1]}</td>
                        <td className="value">{fixedValue[2]}</td>
                        <td className="value">{fixedValue[3]}</td>
                    </tr>
                )}
            </>
        );
    });
    let statConfidenceIntervalsTable3 = (
        <>
            <div key="12341">
                {/* <Row className="statistics-row-box" gutter={16}> */}
                <div>
                    <div>
                        <table className="table-cis second">
                            <thead>
                                <tr>
                                    <th>Confidence Interval</th>
                                    <th>50% </th>
                                    <th>68% </th>
                                    <th>90% </th>
                                    <th>95% </th>
                                </tr>
                            </thead>
                            <tbody>{newStatsConfidenceIntervalsRows3}</tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );

    let fullStats = (
        <div ref={props.forwardedRefStatistics}>
            {statConfidenceIntervalsTable2}
            {statConfidenceIntervalsTable3}
        </div>
    );

    return <>{fullStats}</>;
};

export default React.memo(ConfidenceIntervalsStatistics);
